
import { type OriginFilter } from '@/features/providers/types'

export const ORIGIN_FILTERS: { key: OriginFilter; label: string; tip: string }[] = [
  { key: 'all', label: 'All', tip: 'Every provider this org knows about, auto-discovered and added by hand alike. All are managed: scanned, built from source, CVE-patched where fixes exist, and served per the serve mode.' },
  { key: 'discovered', label: 'Auto-discovered', tip: 'Surfaced from module required_providers or workspace lock files. Managed automatically the moment a scan sees them.' },
  { key: 'manual', label: 'Added manually', tip: 'Added through the Add provider form because nothing in the org referenced them yet.' },
]
